"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentSchemaDef = exports.componentQualificationMinSchemaDef = exports.componentSectionDocSchemaDef = exports.componentSectionSchemaDef = exports.entryComponent = exports.componentTypeSchemaField = exports.SamplingAlgorithm = void 0;
const joi_1 = __importDefault(require("joi"));
const Qualification_1 = require("./Qualification");
const schemaValidator_1 = require("../../util/schemaValidator");
const fileFormats_1 = require("../fileFormats");
const general_1 = require("../general");
const ComponentSeries_1 = require("./ComponentSeries");
const BusinessUnit_1 = require("./BusinessUnit");
const component_1 = require("../component");
var SamplingAlgorithm;
(function (SamplingAlgorithm) {
    SamplingAlgorithm["NoSampling"] = "no-sampling";
    SamplingAlgorithm["OcrGq"] = "ocr-gq";
    SamplingAlgorithm["CiGq"] = "ci-gq";
})(SamplingAlgorithm = exports.SamplingAlgorithm || (exports.SamplingAlgorithm = {}));
exports.componentTypeSchemaField = joi_1.default.string().valid(component_1.ComponentType.MODERATED, component_1.ComponentType.EXAMINED);
exports.entryComponent = {
    name: joi_1.default.string().required(),
    number: joi_1.default.string().required(),
    additionalFileTypes: (0, schemaValidator_1.arraySchema)(fileFormats_1.fileTypeSchemaDef).default([]),
    type: exports.componentTypeSchemaField.required(),
    submissionValidation: joi_1.default.string().valid(...Object.values(component_1.ComponentValidation)),
    sample: joi_1.default.array().default([]),
    receiveSamples: joi_1.default.boolean(),
    maxMark: joi_1.default.number(),
    receiveMarks: joi_1.default.boolean(),
    samplingAlgorithm: joi_1.default.string().valid(SamplingAlgorithm.NoSampling, SamplingAlgorithm.OcrGq, SamplingAlgorithm.CiGq),
};
exports.componentSectionSchemaDef = {
    id: joi_1.default.number().min(0).max(99).required(),
    name: joi_1.default.string().required(),
    fileTypes: (0, schemaValidator_1.arraySchema)(fileFormats_1.fileTypeSchemaDef).default([]),
    plagiarismAndCollusion: joi_1.default.boolean().default(false),
    multipleCandidates: joi_1.default.boolean().default(false),
    allowMultipleFiles: joi_1.default.boolean(),
};
exports.componentSectionDocSchemaDef = {
    id: joi_1.default.number().min(0).max(99).required(),
    name: joi_1.default.string().required(),
    fileTypes: (0, schemaValidator_1.arraySchema)(fileFormats_1.fileTypeSchemaDef).default([]),
    isMandatory: joi_1.default.boolean().default(true).required(),
    allowMultipleFiles: joi_1.default.boolean(),
};
exports.componentQualificationMinSchemaDef = {
    id: Qualification_1.qualificationMinSchemaDef.id,
    name: Qualification_1.qualificationMinSchemaDef.name,
};
exports.componentSchemaDef = Object.assign(Object.assign(Object.assign({}, general_1.daoObjSchemaDef), exports.entryComponent), { businessUnit: (0, schemaValidator_1.objectSchema)(BusinessUnit_1.businessUnitSchemaDef).required(), qualification: (0, schemaValidator_1.objectSchema)(exports.componentQualificationMinSchemaDef).required(), assessment: (0, schemaValidator_1.objectSchema)(Qualification_1.assessmentSchemaDef).required(), sections: (0, schemaValidator_1.arraySchema)(exports.componentSectionSchemaDef).default([]), componentSections: (0, schemaValidator_1.arraySchema)(exports.componentSectionDocSchemaDef).default([]), series: (0, schemaValidator_1.arraySchema)(ComponentSeries_1.componentSeriesSchemaDef).default([]), samplingAlgorithm: joi_1.default.string().valid('no-sampling', 'ocr-gq', 'ci-gq'), receiveSamples: joi_1.default.boolean().default(false), receiveMarks: joi_1.default.boolean().default(null), isExam: joi_1.default.boolean().default(false), toBeConfirmed: joi_1.default.boolean().required(), maxMark: joi_1.default.number(), allowAdditionalWorkSubmission: joi_1.default.boolean().optional(), templateUploadedAt: joi_1.default.string().optional(), isPoE: joi_1.default.boolean() });
